import { render, staticRenderFns } from "./DoctorsIncomeReport.vue?vue&type=template&id=54573f4d"
import script from "./DoctorsIncomeReport.vue?vue&type=script&lang=js"
export * from "./DoctorsIncomeReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports